const parameterIdToSourceIdMap = {
  controllerStartups: 2,
  evacuationSwitchings: 3,
  fatalFaults: 4,
  workError: 5,
  groupWorkErrors: 7,
  driveUpStarts: 8,
  driveDownStarts: 9,
  driveUpRuntime: 10,
  driveDownRuntime: 11,
  forcedBrakingMoveUp: 12,
  forcedBrakingMoveDown: 13,
  carMileage: 14,
  brake1MicroswitchTrips: 15,
  brake2MicroswitchTrips: 16,
  emptyCarRuntime: 17,
  partLoadCarRuntime: 18,
  fullLoadCarRuntime: 19,
  signalVKOSwitchings: 21,
  signalVKZSwitchings: 22,
  signal15kgSwitchings: 23,
  signal90pSwitchings: 24,
  signal110pSwitchings: 25,
  signalDoorControlSideASwitchings: 26,
  signalDoorControlSideBSwitchings: 27,
  signalVBRSwitchings: 28,
  signalTOSwitchings: 29,
  signalDNESwitchings: 30,
  signalAdd2DNESwitchings: 32,
  signalDVESwitchings: 33,
  signalAdd1DVESwitchings: 34,
  signalAdd2DVESwitchings: 35,
  signalDVVSwitchings: 36,
  signalDVNSwitchings: 37,
  signalMBMSwitchings: 38,
  signalONKMCSwitchings: 39,
  signalRKBSwitchings: 40,
  signalKDSSwitchings: 41,
  signalK7Switchings: 42,
  btnOpenDoorSwitchings: 43,
  btnCloseDoorSwitchings: 44,
  btnCancelSwitchings: 45,
  btnFanSwitchings: 46,
  registeredCalls: 47,
  totalTrips: 49,
  timeOfSignalOpenDoorsB: 51,
  timeOfSignalCloseDoorsA: 52,
  timeOfSignalCloseDoorsB: 53,
  bottomEdgeLevelD1: 54,
  topEdgeLevelD1: 55,
  floorVarCount: 56,
  upCalls01: 57,
  downCalls01: 58,
  orders01: 59,
  doorsOpened01: 60,
  doorsClosed01: 61,
  upCalls02: 62,
  downCalls02: 63,
  orders02: 64,
  doorsOpened02: 65,
  upCalls03: 67,
  downCalls03: 68,
  orders03: 69,
  doorsOpened03: 70,
  doorsClosed03: 71,
  upCalls04: 72,
  downCalls04: 73,
  orders04: 74,
  doorsOpened04: 75,
  doorsClosed04: 76,
  upCalls05: 77,
  downCalls05: 78,
  orders05: 79,
  doorsClosed05: 81,
  upCalls06: 82,
  downCalls06: 83,
  orders06: 84,
  doorsOpened06: 85,
  doorsClosed06: 86,
  upCalls07: 87,
  downCalls07: 88,
  orders07: 89,
  doorsOpened07: 90,
  doorsClosed07: 91,
  upCalls08: 92,
  downCalls08: 93,
  doorsOpened08: 95,
  doorsClosed08: 96,
  upCalls09: 97,
  downCalls09: 98,
  orders09: 99,
  doorsOpened09: 100,
  mC5_SK9: 324,
  upCalls10: 102,
  downCalls10: 103,
  orders10: 104,
  doorsOpened10: 105,
  upCalls11: 107,
  downCalls11: 108,
  orders11: 109,
  doorsOpened11: 110,
  doorsClosed11: 111,
  upCalls12: 112,
  downCalls12: 113,
  orders12: 114,
  doorsOpened12: 115,
  doorsClosed12: 116,
  upCalls13: 117,
  downCalls13: 118,
  orders13: 119,
  doorsClosed13: 121,
  upCalls14: 122,
  downCalls14: 123,
  orders14: 124,
  doorsOpened14: 125,
  doorsClosed14: 126,
  upCalls15: 127,
  downCalls15: 128,
  orders15: 129,
  doorsOpened15: 130,
  doorsClosed15: 131,
  upCalls16: 132,
  downCalls16: 133,
  orders16: 134,
  doorsClosed16: 136,
  upCalls17: 137,
  downCalls17: 138,
  orders17: 139,
  doorsOpened17: 140,
  doorsClosed17: 141,
  upCalls18: 142,
  downCalls18: 143,
  orders18: 144,
  doorsOpened18: 145,
  doorsClosed18: 146,
  upCalls19: 147,
  downCalls19: 148,
  orders19: 149,
  doorsClosed19: 151,
  upCalls20: 152,
  orders20: 154,
  doorsOpened20: 155,
  doorsClosed20: 156,
  upCalls21: 157,
  downCalls21: 158,
  orders21: 159,
  doorsClosed21: 161,
  upCalls22: 162,
  downCalls22: 163,
  orders22: 164,
  doorsOpened22: 165,
  doorsClosed22: 166,
  upCalls23: 167,
  downCalls23: 168,
  orders23: 169,
  doorsOpened23: 170,
  doorsClosed23: 171,
  upCalls24: 172,
  downCalls24: 173,
  orders24: 174,
  doorsClosed24: 176,
  upCalls25: 177,
  downCalls25: 178,
  orders25: 179,
  doorsOpened25: 180,
  doorsClosed25: 181,
  upCalls26: 182,
  downCalls26: 183,
  orders26: 184,
  doorsOpened26: 185,
  doorsClosed26: 186,
  upCalls27: 187,
  orders27: 189,
  doorsOpened27: 190,
  doorsClosed27: 191,
  upCalls28: 192,
  downCalls28: 193,
  orders28: 194,
  doorsOpened28: 195,
  doorsClosed28: 196,
  upCalls29: 197,
  downCalls29: 198,
  orders29: 199,
  doorsOpened29: 200,
  upCalls30: 202,
  downCalls30: 203,
  orders30: 204,
  doorsClosed30: 206,
  upCalls31: 207,
  downCalls31: 208,
  orders31: 209,
  doorsOpened31: 210,
  doorsClosed31: 211,
  upCalls32: 212,
  downCalls32: 213,
  orders32: 214,
  doorsClosed32: 216,
  NBFWascii: 217,
  mornModeStartM: 218,
  mornModeStartH: 219,
  mornModeEndM: 220,
  mornModeEndH: 221,
  dayModeStartM: 222,
  dayModeStartH: 223,
  dayModeEndM: 224,
  dayModeEndH: 225,
  evenModeStartM: 226,
  evenModeStartH: 227,
  evenModeEndM: 228,
  evenModeEndH: 229,
  sleepModeStartH: 231,
  sleepModeEndM: 232,
  sleepModeEndH: 233,
  timeSec: 234,
  timeMin: 235,
  timeHour: 236,
  timeWDay: 237,
  timeMDay: 238,
  timeMonth: 239,
  timeYear: 240,
  sleepModeStatus: 241,
  dayModeStatus: 243,
  evenModeStatus: 244,
  framFault: 245,
  timeFault: 246,
  SBFWint: 247,
  stationManufacturerCode: 248,
  stationSerial: 249,
  elevatorManufacturerCode: 250,
  elevatorSerial: 251,
  placeCountryCode: 252,
  placeRegion: 253,
  placeCity: 254,
  placeAddress: 255,
  elevatorComment: 257,
  SBFWascii: 258,
  lastPowerUpSec: 259,
  lastPowerUpMin: 260,
  lastPowerUpHour: 261,
  lastPowerUpMDay: 263,
  lastPowerUpMonth: 264,
  controllerUptime: 266,
  FCUpCmd: 267,
  FCDownCmd: 268,
  FCDECCmd: 269,
  FCLSCmd: 270,
  FCHSCmd: 271,
  FCRSTCmd: 273,
  FCBXSgl: 274,
  MDReadySgl: 275,
  MDRunSgl: 276,
  BRCxControlFlag: 277,
  ONKMCSgl: 278,
  BRC2Sgl: 279,
  BRC1Sgl: 280,
  tempSens1Sgl: 281,
  tempSens2Sgl: 282,
  LKMCCmd: 283,
  LKM1Cmd: 284,
  LKM2Cmd: 285,
  carLightCmd: 287,
  carFanCmd: 288,
  gongCmd: 289,
  TOSensorSgl: 290,
  DNESensorSgl: 291,
  DVESensorSgl: 292,
  realCarDirection: 293,
  carFireAlarmSgl: 295,
  buildingFireAlarmSgl: 296,
  DNE2SensorSgl: 297,
  DVE2SensorSgl: 298,
  DNE1SensorSgl: 299,
  DVE1SensorSgl: 300,
  DVNSensorSgl: 301,
  DVVSensorSgl: 302,
  MBMSgl: 303,
  can0ConState: 304,
  can1ConState: 305,
  can2ConState: 306,
  can3ConState: 307,
  can4ConState: 308,
  can5ConState: 309,
  can6ConState: 310,
  can7ConState: 311,
  can9ConState: 313,
  can10ConState: 314,
  can11ConState: 315,
  can12ConState: 316,
  can13ConState: 317,
  can14ConState: 318,
  can15ConState: 319,
  mC1_SK9: 320,
  mC2_SK9: 321,
  mC3_SK9: 322,
  mC4_SK9: 323,
  order13: 1865,
  mC8_SK9: 327,
  mC1_SK10: 328,
  mC2_SK10: 329,
  mC3_SK10: 330,
  mC4_SK10: 331,
  mC5_SK10: 332,
  mC6_SK10: 333,
  mC7_SK10: 334,
  mC8_SK10: 335,
  mC1_SK11: 336,
  mC3_SK11: 338,
  mC4_SK11: 339,
  mC5_SK11: 340,
  mC6_SK11: 341,
  mC7_SK11: 342,
  mC8_SK11: 343,
  mC1_SK12: 344,
  mC2_SK12: 345,
  mC3_SK12: 346,
  mC5_SK12: 348,
  mC6_SK12: 349,
  mC7_SK12: 350,
  mC8_SK12: 351,
  mC1_SK13: 352,
  mC2_SK13: 353,
  mC3_SK13: 354,
  mC4_SK13: 355,
  mC5_SK13: 356,
  mC7_SK13: 358,
  mC8_SK13: 359,
  mC1_SK14: 360,
  mC2_SK14: 361,
  mC3_SK14: 362,
  mC4_SK14: 363,
  mC5_SK14: 364,
  mC6_SK14: 365,
  mC7_SK14: 366,
  mC8_SK14: 367,
  mC2_SK15: 369,
  mC3_SK15: 370,
  mC4_SK15: 371,
  mC5_SK15: 372,
  mC6_SK15: 373,
  mC7_SK15: 374,
  mC8_SK15: 375,
  mC1_SK16: 376,
  mC2_SK16: 377,
  mC4_SK16: 379,
  mC5_SK16: 380,
  mC6_SK16: 381,
  mC7_SK16: 382,
  mC8_SK16: 383,
  shaftDoorsState: 385,
  shaftGuardState: 386,
  safetyChainState: 387,
  phaseControlRelayState: 388,
  KDSRelayState: 389,
  K7RelayState: 390,
  manualControlUpBtn: 391,
  manualControlDownBtn: 392,
  w15kgSgl: 394,
  w90pSgl: 395,
  w110pSgl: 396,
  revisionUpBtn: 397,
  revisionDownBtn: 398,
  revisionKeyState: 399,
  carHatchSensorSgl: 400,
  openDoorABtn: 401,
  closeDoorBtn: 402,
  cancelBtn: 403,
  openDoorBBtn: 404,
  dispatcherBtn: 405,
  conductorKeyState: 406,
  fanBtn: 407,
  PPPKeyState: 408,
  openDoorSideACmd: 409,
  closeDoorSideACmd: 410,
  VKZDoorSideASgl: 412,
  VBRDoorSideASgl: 413,
  doorControlSensorSideASgl: 414,
  MBMInstalledSideAFlag: 415,
  blockSideAFlag: 416,
  openDoorSideBCmd: 417,
  closeDoorSideBCmd: 418,
  VKODoorSideBSgl: 419,
  VKZDoorSideBSgl: 420,
  VBRDoorSideBSgl: 421,
  doorControlSensorSideBSgl: 422,
  blockSideBFlag: 424,
  liftHeightFractional: 425,
  currentLevel: 427,
  carSpeedFractional: 428,
  speedRelevance: 429,
  accelerateState: 431,
  mC1_SK1: 432,
  mC2_SK1: 433,
  mC3_SK1: 434,
  mC4_SK1: 435,
  mC5_SK1: 436,
  mC6_SK1: 437,
  mC7_SK1: 438,
  mC8_SK1: 439,
  mC1_SK2: 440,
  mC2_SK2: 441,
  mC3_SK2: 442,
  mC4_SK2: 443,
  mC5_SK2: 444,
  mC6_SK2: 445,
  mC7_SK2: 446,
  mC8_SK2: 447,
  mC2_SK3: 449,
  mC3_SK3: 450,
  mC4_SK3: 451,
  mC5_SK3: 452,
  mC6_SK3: 453,
  liftHeightWhole: 426,
  mC8_SK3: 455,
  mC1_SK4: 456,
  mC3_SK4: 458,
  mC4_SK4: 459,
  mC5_SK4: 460,
  mC6_SK4: 461,
  mC7_SK4: 462,
  mC8_SK4: 463,
  mC1_SK5: 464,
  mC2_SK5: 465,
  mC3_SK5: 466,
  mC4_SK5: 467,
  mC6_SK5: 469,
  mC7_SK5: 470,
  mC8_SK5: 471,
  mC1_SK6: 472,
  mC2_SK6: 473,
  mC3_SK6: 474,
  mC4_SK6: 475,
  mC5_SK6: 476,
  mC6_SK6: 477,
  mC8_SK6: 479,
  mC1_SK7: 480,
  mC2_SK7: 481,
  mC3_SK7: 482,
  mC4_SK7: 483,
  mC5_SK7: 484,
  mC6_SK7: 485,
  mC7_SK7: 486,
  mC8_SK7: 487,
  mC2_SK8: 489,
  mC3_SK8: 490,
  mC4_SK8: 491,
  mC5_SK8: 492,
  mC6_SK8: 493,
  mC7_SK8: 494,
  mC8_SK8: 495,
  mC1_SK17: 496,
  mC2_SK17: 497,
  mC3_SK17: 498,
  mC5_SK17: 500,
  mC6_SK17: 501,
  mC7_SK17: 502,
  mC8_SK17: 503,
  mC1_SK18: 504,
  mC2_SK18: 505,
  mC3_SK18: 506,
  mC4_SK18: 507,
  mC5_SK18: 508,
  mC7_SK18: 510,
  mC8_SK18: 511,
  mC1_SK19: 512,
  shaftDoorsState52: 1231,
  mC3_SK19: 514,
  mC4_SK19: 515,
  mC5_SK19: 516,
  mC6_SK19: 517,
  mC7_SK19: 518,
  mC1_SK20: 520,
  mC2_SK20: 521,
  mC3_SK20: 522,
  mC4_SK20: 523,
  mC6_SK20: 525,
  mC7_SK20: 526,
  mC1_SK21: 528,
  mC2_SK21: 529,
  mC3_SK21: 530,
  mC4_SK21: 531,
  mC5_SK21: 532,
  mC6_SK21: 533,
  mC7_SK21: 534,
  mC8_SK21: 535,
  mC1_SK22: 536,
  mC3_SK22: 538,
  mC4_SK22: 539,
  mC5_SK22: 540,
  mC6_SK22: 541,
  mC7_SK22: 542,
  mC8_SK22: 543,
  mC1_SK23: 544,
  mC2_SK23: 545,
  mC3_SK23: 546,
  mC5_SK23: 548,
  mC6_SK23: 549,
  mC7_SK23: 550,
  mC8_SK23: 551,
  mC1_SK24: 552,
  mC2_SK24: 553,
  mC3_SK24: 554,
  mC4_SK24: 555,
  mC5_SK24: 556,
  mC6_SK24: 557,
  mC8_SK24: 559,
  workMode: 560,
  correctionTripFlag: 561,
  dailyMode: 562,
  FCTrialLaunchingFlag: 563,
  elevatorState: 564,
  displayCarDirection: 565,
  mainDriveBlockFlag: 567,
  carDoorsDriveBlockFlag: 568,
  warningFlag: 569,
  errorFlag: 570,
  fatalFaultFlag: 571,
  floorDisplayLowSymbol: 572,
  floorDisplayHighSymbol: 573,
  floorDisplaySignSymbol: 574,
  lastErrorCodeLowByte: 575,
  givenCarDirection: 577,
  systemBlockFlag: 578,
  nonStandardSituationFlag: 579,
  destinationLevel: 580,
  litOrder01: 581,
  litOrder02: 582,
  litOrder03: 583,
  litOrder04: 584,
  litOrder05: 585,
  litOrder06: 586,
  litOrder07: 587,
  litOrder08: 588,
  litOrder09: 589,
  litOrder11: 591,
  litOrder12: 592,
  litOrder13: 593,
  litOrder14: 594,
  litOrder16: 596,
  litOrder17: 597,
  litOrder18: 598,
  litOrder19: 599,
  litOrder20: 600,
  litOrder21: 601,
  litOrder22: 602,
  litOrder23: 603,
  litOrder24: 604,
  litOrder25: 605,
  litOrder27: 607,
  litOrder28: 608,
  litOrder29: 609,
  litOrder30: 610,
  litOrder31: 611,
  litOrder32: 612,
  litOrder33: 613,
  litOrder34: 614,
  litOrder35: 615,
  litOrder37: 617,
  litOrder38: 618,
  litOrder39: 619,
  shaftDoorsState53: 1232,
  litOrder41: 621,
  litOrder42: 622,
  litOrder43: 623,
  litOrder44: 624,
  litOrder45: 625,
  litOrder47: 627,
  litOrder48: 628,
  litOrder49: 629,
  litOrder50: 630,
  litOrder51: 631,
  litOrder52: 632,
  litOrder53: 633,
  litOrder54: 634,
  litOrder55: 635,
  litOrder56: 636,
  litOrder58: 638,
  litOrder59: 639,
  litOrder60: 640,
  litOrder61: 641,
  litOrder62: 642,
  litOrder63: 643,
  litOrder64: 644,
  btnPressOrder01: 645,
  btnPressOrder03: 647,
  btnPressOrder04: 648,
  btnPressOrder05: 649,
  btnPressOrder06: 650,
  btnPressOrder07: 651,
  btnPressOrder08: 652,
  btnPressOrder09: 653,
  btnPressOrder10: 654,
  btnPressOrder11: 655,
  btnPressOrder12: 656,
  btnPressOrder15: 659,
  btnPressOrder16: 660,
  btnPressOrder17: 661,
  btnPressOrder18: 662,
  btnPressOrder19: 663,
  btnPressOrder20: 664,
  btnPressOrder22: 666,
  btnPressOrder23: 667,
  btnPressOrder24: 668,
  btnPressOrder25: 669,
  btnPressOrder26: 670,
  btnPressOrder27: 671,
  btnPressOrder28: 672,
  btnPressOrder29: 673,
  btnPressOrder30: 674,
  btnPressOrder31: 675,
  btnPressOrder33: 677,
  btnPressOrder34: 678,
  btnPressOrder35: 679,
  btnPressOrder36: 680,
  btnPressOrder37: 681,
  btnPressOrder38: 682,
  btnPressOrder39: 683,
  btnPressOrder40: 684,
  btnPressOrder41: 685,
  btnPressOrder42: 686,
  btnPressOrder43: 687,
  btnPressOrder45: 689,
  btnPressOrder46: 690,
  btnPressOrder47: 691,
  btnPressOrder48: 692,
  btnPressOrder49: 693,
  btnPressOrder50: 694,
  btnPressOrder51: 695,
  btnPressOrder52: 696,
  btnPressOrder53: 697,
  btnPressOrder54: 698,
  btnPressOrder55: 699,
  btnPressOrder57: 701,
  btnPressOrder58: 702,
  btnPressOrder59: 703,
  btnPressOrder60: 704,
  btnPressOrder61: 705,
  btnPressOrder62: 706,
  btnPressOrder63: 707,
  btnPressOrder64: 708,
  litUpCall01: 709,
  litUpCall02: 710,
  litUpCall03: 711,
  litUpCall05: 713,
  litUpCall06: 714,
  litUpCall07: 715,
  litUpCall08: 716,
  litUpCall09: 717,
  litUpCall10: 718,
  litUpCall11: 719,
  order14: 1866,
  litUpCall13: 721,
  litUpCall15: 723,
  litUpCall16: 724,
  litUpCall17: 725,
  litUpCall18: 726,
  litUpCall19: 727,
  litUpCall20: 728,
  litUpCall21: 729,
  litUpCall22: 730,
  litUpCall23: 731,
  litUpCall24: 732,
  litUpCall26: 734,
  litUpCall27: 735,
  litUpCall28: 736,
  litUpCall29: 737,
  litUpCall30: 738,
  litUpCall31: 739,
  litUpCall32: 740,
  litUpCall33: 741,
  litUpCall34: 742,
  litUpCall35: 743,
  litUpCall37: 745,
  litUpCall38: 746,
  litUpCall39: 747,
  litUpCall40: 748,
  litUpCall41: 749,
  litUpCall42: 750,
  litUpCall43: 751,
  litUpCall44: 752,
  litUpCall45: 753,
  litUpCall46: 754,
  litUpCall48: 756,
  litUpCall49: 757,
  litUpCall50: 758,
  litUpCall51: 759,
  litUpCall52: 760,
  litUpCall53: 761,
  litUpCall54: 762,
  litUpCall55: 763,
  litUpCall56: 764,
  litUpCall57: 765,
  litUpCall59: 767,
  litUpCall60: 768,
  litUpCall61: 769,
  litUpCall62: 770,
  litUpCall63: 771,
  litUpCall64: 772,
  btnPressUpCall01: 773,
  btnPressUpCall02: 774,
  btnPressUpCall04: 776,
  btnPressUpCall05: 777,
  btnPressUpCall06: 778,
  btnPressUpCall07: 779,
  btnPressUpCall08: 780,
  btnPressUpCall09: 781,
  btnPressUpCall10: 782,
  btnPressUpCall12: 784,
  btnPressUpCall13: 785,
  btnPressUpCall14: 786,
  btnPressUpCall15: 787,
  btnPressUpCall17: 789,
  btnPressUpCall18: 790,
  btnPressUpCall19: 791,
  btnPressUpCall20: 792,
  btnPressUpCall21: 793,
  btnPressUpCall22: 794,
  btnPressUpCall23: 795,
  btnPressUpCall24: 796,
  btnPressUpCall25: 797,
  btnPressUpCall26: 798,
  btnPressUpCall27: 799,
  btnPressUpCall28: 800,
  btnPressUpCall30: 802,
  btnPressUpCall31: 803,
  btnPressUpCall32: 804,
  btnPressUpCall33: 805,
  btnPressUpCall34: 806,
  btnPressUpCall35: 807,
  btnPressUpCall36: 808,
  btnPressUpCall37: 809,
  btnPressUpCall38: 810,
  btnPressUpCall39: 811,
  btnPressUpCall40: 812,
  btnPressUpCall41: 813,
  btnPressUpCall43: 815,
  btnPressUpCall44: 816,
  btnPressUpCall45: 817,
  btnPressUpCall46: 818,
  btnPressUpCall47: 819,
  btnPressUpCall48: 820,
  btnPressUpCall49: 821,
  btnPressUpCall50: 822,
  btnPressUpCall51: 823,
  btnPressUpCall52: 824,
  btnPressUpCall53: 825,
  btnPressUpCall54: 826,
  btnPressUpCall56: 828,
  btnPressUpCall57: 829,
  btnPressUpCall58: 830,
  btnPressUpCall59: 831,
  btnPressUpCall60: 832,
  btnPressUpCall61: 833,
  btnPressUpCall62: 834,
  btnPressUpCall63: 835,
  btnPressUpCall64: 836,
  litDownCall01: 837,
  litDownCall03: 839,
  litDownCall04: 840,
  litDownCall05: 841,
  litDownCall06: 842,
  litDownCall07: 843,
  litDownCall09: 845,
  litDownCall10: 846,
  litDownCall11: 847,
  litDownCall12: 848,
  litDownCall13: 849,
  litDownCall14: 850,
  litDownCall15: 851,
  litDownCall16: 852,
  litDownCall17: 853,
  litDownCall18: 854,
  litDownCall20: 856,
  litDownCall21: 857,
  litDownCall22: 858,
  litDownCall23: 859,
  litDownCall24: 860,
  litDownCall25: 861,
  litDownCall26: 862,
  litDownCall27: 863,
  litDownCall28: 864,
  litDownCall29: 865,
  litDownCall31: 867,
  litDownCall32: 868,
  litDownCall33: 869,
  litDownCall34: 870,
  litDownCall35: 871,
  litDownCall36: 872,
  litDownCall37: 873,
  litDownCall38: 874,
  litDownCall39: 875,
  litDownCall40: 876,
  litDownCall42: 878,
  litDownCall43: 879,
  litDownCall44: 880,
  litDownCall45: 881,
  litDownCall46: 882,
  litDownCall47: 883,
  litDownCall48: 884,
  litDownCall49: 885,
  litDownCall50: 886,
  litDownCall51: 887,
  litDownCall53: 889,
  litDownCall54: 890,
  litDownCall55: 891,
  litDownCall56: 892,
  litDownCall57: 893,
  litDownCall58: 894,
  litDownCall59: 895,
  litDownCall60: 896,
  litDownCall61: 897,
  litDownCall62: 898,
  litDownCall64: 900,
  btnPressDownCall01: 901,
  btnPressDownCall02: 902,
  btnPressDownCall04: 904,
  btnPressDownCall05: 905,
  btnPressDownCall07: 907,
  btnPressDownCall08: 908,
  btnPressDownCall09: 909,
  btnPressDownCall10: 910,
  btnPressDownCall11: 911,
  btnPressDownCall12: 912,
  btnPressDownCall13: 913,
  btnPressDownCall14: 914,
  btnPressDownCall15: 915,
  btnPressDownCall16: 916,
  btnPressDownCall17: 917,
  btnPressDownCall18: 918,
  btnPressDownCall20: 920,
  btnPressDownCall21: 921,
  btnPressDownCall22: 922,
  btnPressDownCall23: 923,
  btnPressDownCall24: 924,
  btnPressDownCall25: 925,
  btnPressDownCall26: 926,
  btnPressDownCall27: 927,
  btnPressDownCall28: 928,
  btnPressDownCall29: 929,
  btnPressDownCall30: 930,
  btnPressDownCall31: 931,
  btnPressDownCall33: 933,
  btnPressDownCall34: 934,
  btnPressDownCall35: 935,
  btnPressDownCall36: 936,
  btnPressDownCall37: 937,
  btnPressDownCall38: 938,
  btnPressDownCall39: 939,
  btnPressDownCall40: 940,
  btnPressDownCall41: 941,
  btnPressDownCall42: 942,
  btnPressDownCall43: 943,
  btnPressDownCall44: 944,
  btnPressDownCall46: 946,
  btnPressDownCall47: 947,
  btnPressDownCall48: 948,
  btnPressDownCall49: 949,
  btnPressDownCall50: 950,
  btnPressDownCall51: 951,
  btnPressDownCall52: 952,
  btnPressDownCall53: 953,
  btnPressDownCall54: 954,
  btnPressDownCall55: 955,
  btnPressDownCall56: 956,
  btnPressDownCall57: 957,
  btnPressDownCall59: 959,
  btnPressDownCall60: 960,
  btnPressDownCall61: 961,
  btnPressDownCall62: 962,
  btnPressDownCall64: 964,
  sideADoorBlock01: 965,
  shaftDoorsState54: 1233,
  shaftDoorsState55: 1234,
  shaftDoorsState56: 1235,
  shaftDoorsState57: 1236,
  shaftDoorsState58: 1237,
  shaftDoorsState59: 1238,
  shaftDoorsState60: 1239,
  shaftDoorsState61: 1240,
  shaftDoorsState62: 1241,
  shaftDoorsState63: 1242,
  shaftDoorsState64: 1243,
  rightSymbolLevel01: 1245,
  leftSymbolLevel02: 1246,
  rightSymbolLevel02: 1247,
  leftSymbolLevel03: 1248,
  rightSymbolLevel03: 1249,
  leftSymbolLevel04: 1250,
  rightSymbolLevel04: 1251,
  leftSymbolLevel05: 1252,
  rightSymbolLevel05: 1253,
  leftSymbolLevel06: 1254,
  leftSymbolLevel07: 1256,
  rightSymbolLevel07: 1257,
  leftSymbolLevel08: 1258,
  rightSymbolLevel08: 1259,
  leftSymbolLevel09: 1260,
  rightSymbolLevel09: 1261,
  leftSymbolLevel10: 1262,
  rightSymbolLevel10: 1263,
  leftSymbolLevel11: 1264,
  rightSymbolLevel11: 1265,
  leftSymbolLevel12: 1266,
  rightSymbolLevel12: 1267,
  leftSymbolLevel13: 1268,
  leftSymbolLevel14: 1270,
  rightSymbolLevel14: 1271,
  leftSymbolLevel15: 1272,
  rightSymbolLevel15: 1273,
  leftSymbolLevel16: 1274,
  rightSymbolLevel16: 1275,
  leftSymbolLevel17: 1276,
  rightSymbolLevel17: 1277,
  leftSymbolLevel18: 1278,
  rightSymbolLevel18: 1279,
  leftSymbolLevel19: 1280,
  leftSymbolLevel21: 1284,
  rightSymbolLevel21: 1285,
  leftSymbolLevel22: 1286,
  rightSymbolLevel22: 1287,
  leftSymbolLevel23: 1288,
  rightSymbolLevel23: 1289,
  leftSymbolLevel24: 1290,
  rightSymbolLevel24: 1291,
  leftSymbolLevel25: 1292,
  rightSymbolLevel25: 1293,
  leftSymbolLevel26: 1294,
  leftSymbolLevel27: 1296,
  rightSymbolLevel27: 1297,
  leftSymbolLevel28: 1298,
  rightSymbolLevel28: 1299,
  leftSymbolLevel29: 1300,
  sideBDoorBlock01: 1029,
  rightSymbolLevel29: 1301,
  leftSymbolLevel30: 1302,
  rightSymbolLevel30: 1303,
  leftSymbolLevel31: 1304,
  rightSymbolLevel31: 1305,
  leftSymbolLevel32: 1306,
  downwardLeveling01: 1308,
  upwardLeveling01: 1309,
  downwardLeveling02: 1310,
  upwardLeveling02: 1311,
  downwardLeveling03: 1312,
  upwardLeveling03: 1313,
  downwardLeveling04: 1314,
  upwardLeveling04: 1315,
  downwardLeveling05: 1316,
  upwardLeveling05: 1317,
  downwardLeveling06: 1318,
  downwardLeveling07: 1320,
  upwardLeveling07: 1321,
  downwardLeveling08: 1322,
  upwardLeveling08: 1323,
  downwardLeveling09: 1324,
  upwardLeveling09: 1325,
  downwardLeveling10: 1326,
  upwardLeveling10: 1327,
  downwardLeveling11: 1328,
  upwardLeveling11: 1329,
  downwardLeveling12: 1330,
  upwardLeveling12: 1331,
  downwardLeveling13: 1332,
  order43: 1895,
  upwardLeveling14: 1335,
  upwardLeveling15: 1337,
  downwardLeveling16: 1338,
  upwardLeveling16: 1339,
  downwardLeveling17: 1340,
  upwardLeveling17: 1341,
  downwardLeveling18: 1342,
  upwardLeveling18: 1343,
  downwardLeveling19: 1344,
  upwardLeveling19: 1345,
  downwardLeveling20: 1346,
  upwardLeveling20: 1347,
  downwardLeveling21: 1348,
  upwardLeveling21: 1349,
  upwardLeveling22: 1351,
  downwardLeveling23: 1352,
  upwardLeveling23: 1353,
  downwardLeveling24: 1354,
  upwardLeveling24: 1355,
  downwardLeveling25: 1356,
  upwardLeveling25: 1357,
  downwardLeveling26: 1358,
  upwardLeveling26: 1359,
  downwardLeveling27: 1360,
  upwardLeveling27: 1361,
  downwardLeveling28: 1362,
  doorsUndefinedPositionFlag: 1093,
  stationBoxDoorsFlag: 1094,
  madCarModeFlag: 1095,
  madElevatorModeFlag: 1096,
  groupRs485Status: 1098,
  canStatus: 1099,
  dispRs485Status: 1100,
  tempLoadSeconds: 1101,
  tempLoadMinutes: 1102,
  elevatorGroupAddress: 1103,
  collectMode: 1104,
  accessLevelControlFlag: 1105,
  miniEvacuatorMode: 1106,
  activeEvacuatorMode: 1107,
  bottomEdgeLevel: 1109,
  nominalCarSpeed: 1110,
  specialModeFlag: 1111,
  shaftLevelingMode: 1112,
  parFrameReadFailure: 1113,
  parUpdateFlag: 1114,
  dStatFlag: 1115,
  levContCon01: 1116,
  levContCon02: 1117,
  levContCon04: 1119,
  levContCon05: 1120,
  levContCon06: 1121,
  levContCon07: 1122,
  levContCon09: 1124,
  levContCon10: 1125,
  levContCon11: 1126,
  levContCon12: 1127,
  levContCon13: 1128,
  levContCon14: 1129,
  levContCon15: 1130,
  levContCon16: 1131,
  levContCon17: 1132,
  levContCon18: 1133,
  levContCon19: 1134,
  levContCon21: 1136,
  levContCon22: 1137,
  levContCon23: 1138,
  levContCon24: 1139,
  levContCon25: 1140,
  levContCon26: 1141,
  levContCon27: 1142,
  levContCon28: 1143,
  levContCon29: 1144,
  levContCon30: 1145,
  levContCon31: 1146,
  levContCon33: 1148,
  levContCon34: 1149,
  levContCon35: 1150,
  levContCon36: 1151,
  levContCon37: 1152,
  levContCon38: 1153,
  levContCon39: 1154,
  levContCon40: 1155,
  levContCon41: 1156,
  levContCon42: 1157,
  levContCon43: 1158,
  levContCon44: 1159,
  levContCon46: 1161,
  levContCon47: 1162,
  levContCon48: 1163,
  levContCon49: 1164,
  levContCon50: 1165,
  levContCon51: 1166,
  levContCon52: 1167,
  levContCon53: 1168,
  levContCon54: 1169,
  levContCon55: 1170,
  levContCon56: 1171,
  levContCon58: 1173,
  levContCon59: 1174,
  levContCon60: 1175,
  levContCon62: 1177,
  levContCon63: 1178,
  levContCon64: 1179,
  shaftDoorsState01: 1180,
  shaftDoorsState02: 1181,
  shaftDoorsState04: 1183,
  shaftDoorsState05: 1184,
  shaftDoorsState06: 1185,
  shaftDoorsState07: 1186,
  shaftDoorsState08: 1187,
  shaftDoorsState09: 1188,
  shaftDoorsState10: 1189,
  shaftDoorsState11: 1190,
  shaftDoorsState12: 1191,
  shaftDoorsState13: 1192,
  shaftDoorsState14: 1193,
  shaftDoorsState16: 1195,
  shaftDoorsState17: 1196,
  shaftDoorsState18: 1197,
  shaftDoorsState19: 1198,
  shaftDoorsState20: 1199,
  shaftDoorsState21: 1200,
  shaftDoorsState22: 1201,
  shaftDoorsState23: 1202,
  shaftDoorsState24: 1203,
  shaftDoorsState25: 1204,
  shaftDoorsState27: 1206,
  shaftDoorsState28: 1207,
  shaftDoorsState29: 1208,
  shaftDoorsState30: 1209,
  shaftDoorsState31: 1210,
  shaftDoorsState32: 1211,
  shaftDoorsState33: 1212,
  shaftDoorsState34: 1213,
  shaftDoorsState35: 1214,
  shaftDoorsState36: 1215,
  shaftDoorsState37: 1216,
  shaftDoorsState39: 1218,
  shaftDoorsState40: 1219,
  shaftDoorsState41: 1220,
  shaftDoorsState42: 1221,
  shaftDoorsState43: 1222,
  shaftDoorsState44: 1223,
  shaftDoorsState45: 1224,
  shaftDoorsState46: 1225,
  shaftDoorsState47: 1226,
  shaftDoorsState48: 1227,
  shaftDoorsState49: 1228,
  shaftDoorsState51: 1230,
  upwardLeveling28: 1363,
  downwardLeveling29: 1364,
  upwardLeveling29: 1365,
  downwardLeveling30: 1366,
  upwardLeveling30: 1367,
  upwardLeveling31: 1369,
  downwardLeveling32: 1370,
  upwardLeveling32: 1371,
  speed2DecelerationMDist: 1372,
  speed3DecelerationMDist: 1374,
  speed4DecelerationMDist: 1376,
  speed5DecelerationMDist: 1378,
  speed6DecelerationMDist: 1380,
  speed7DecelerationMDist: 1382,
  speed2ZoneMDist: 1384,
  speed3ZoneMDist: 1386,
  speed4ZoneMDist: 1388,
  speed5ZoneMDist: 1390,
  speed6ZoneMDist: 1392,
  speed7ZoneMDist: 1394,
  bottomEdgeLiftHeightL01: 1396,
  bottomEdgeLiftHeightL02: 1397,
  bottomEdgeLiftHeightL03: 1398,
  bottomEdgeLiftHeightL04: 1399,
  bottomEdgeLiftHeightL05: 1400,
  bottomEdgeLiftHeightL06: 1401,
  bottomEdgeLiftHeightL07: 1402,
  bottomEdgeLiftHeightL08: 1403,
  bottomEdgeLiftHeightL09: 1404,
  bottomEdgeLiftHeightL10: 1405,
  bottomEdgeLiftHeightL11: 1406,
  bottomEdgeLiftHeightL12: 1407,
  bottomEdgeLiftHeightL13: 1408,
  bottomEdgeLiftHeightL14: 1409,
  bottomEdgeLiftHeightL15: 1410,
  bottomEdgeLiftHeightL16: 1411,
  bottomEdgeLiftHeightL17: 1412,
  bottomEdgeLiftHeightL18: 1413,
  bottomEdgeLiftHeightL19: 1414,
  bottomEdgeLiftHeightL20: 1415,
  bottomEdgeLiftHeightL21: 1416,
  orderBlock09Prm: 1513,
  bottomEdgeLiftHeightL23: 1418,
  bottomEdgeLiftHeightL24: 1419,
  bottomEdgeLiftHeightL26: 1421,
  bottomEdgeLiftHeightL27: 1422,
  bottomEdgeLiftHeightL28: 1423,
  bottomEdgeLiftHeightL29: 1424,
  bottomEdgeLiftHeightL30: 1425,
  bottomEdgeLiftHeightL31: 1426,
  bottomEdgeLiftHeightL32: 1427,
  topEdgeLiftHeightL01: 1428,
  topEdgeLiftHeightL02: 1429,
  topEdgeLiftHeightL03: 1430,
  topEdgeLiftHeightL04: 1431,
  topEdgeLiftHeightL05: 1432,
  topEdgeLiftHeightL06: 1433,
  topEdgeLiftHeightL07: 1434,
  topEdgeLiftHeightL08: 1435,
  topEdgeLiftHeightL09: 1436,
  topEdgeLiftHeightL11: 1438,
  topEdgeLiftHeightL12: 1439,
  topEdgeLiftHeightL13: 1440,
  topEdgeLiftHeightL14: 1441,
  topEdgeLiftHeightL15: 1442,
  topEdgeLiftHeightL16: 1443,
  topEdgeLiftHeightL17: 1444,
  topEdgeLiftHeightL18: 1445,
  topEdgeLiftHeightL19: 1446,
  topEdgeLiftHeightL20: 1447,
  topEdgeLiftHeightL21: 1448,
  topEdgeLiftHeightL22: 1449,
  topEdgeLiftHeightL23: 1450,
  topEdgeLiftHeightL24: 1451,
  topEdgeLiftHeightL25: 1452,
  topEdgeLiftHeightL26: 1453,
  topEdgeLiftHeightL28: 1455,
  topEdgeLiftHeightL29: 1456,
  topEdgeLiftHeightL30: 1457,
  orderBlock10Prm: 1514,
  topEdgeLiftHeightL32: 1459,
  allottedInGroupElevatorPrm: 1460,
  collectModePrm: 1461,
  lightingControlTypePrm: 1462,
  keyAccessPrm: 1463,
  callingLoadedCarBlockPrm: 1464,
  speedSensorPrm: 1465,
  driveOverheatSymptomPrm: 1466,
  backCarToLandingFloorPrm: 1467,
  parkCarWithOpenedDoorsPrm: 1468,
  extraBorderFloorSensorTypePrm: 1469,
  exactStopLevelingSensorTypePrm: 1470,
  reverseDirectionIndicationPrm: 1471,
  blockDoorDrivePrm: 1472,
  cancelOrderSecondPressPrm: 1473,
  blockFloorWithStuckButtonPrm: 1475,
  brakeControlPrm: 1476,
  assemblyRevisionPrm: 1477,
  borderFloorSensorsConnectionPrm: 1478,
  bottomBorderFloorSensorAreaPrm: 1479,
  fireEmergencySensorTypePrm: 1480,
  brakeSwitchTypePrm: 1481,
  doorControlContactTypePrm: 1482,
  mfi1ContactTypePrm: 1483,
  mfi2ContactTypePrm: 1484,
  mfi3ContactTypePrm: 1485,
  mfi4ContactTypePrm: 1486,
  TOSensorContactTypePrm: 1487,
  DVESensorContactTypePrm: 1488,
  DNESensorContactTypePrm: 1489,
  fireEvacuationFloorPrm: 1490,
  speedLimiterPrm: 1491,
  maxCarSpeedPrm: 1492,
  floorsCountPrm: 1494,
  basementFloorsCountPrm: 1495,
  pickModePrm: 1496,
  landingFloorPrm: 1497,
  openCloseDoorControlTimePrm: 1498,
  betweenOpenCloseDoorControlTimePrm: 1499,
  stoppingTimePrm: 1501,
  groupAddressPrm: 1502,
  tempLoadDurationPrm: 1503,
  fanControlTypePrm: 1504,
  orderBlock01Prm: 1505,
  orderBlock02Prm: 1506,
  orderBlock03Prm: 1507,
  orderBlock04Prm: 1508,
  orderBlock05Prm: 1509,
  orderBlock06Prm: 1510,
  orderBlock08Prm: 1512,
  orderBlock12Prm: 1516,
  orderBlock13Prm: 1517,
  orderBlock14Prm: 1518,
  orderBlock15Prm: 1519,
  orderBlock16Prm: 1520,
  orderBlock17Prm: 1521,
  orderBlock18Prm: 1522,
  orderBlock20Prm: 1524,
  orderBlock21Prm: 1525,
  orderBlock22Prm: 1526,
  orderBlock23Prm: 1527,
  orderBlock24Prm: 1528,
  orderBlock25Prm: 1529,
  orderBlock26Prm: 1530,
  orderBlock27Prm: 1531,
  orderBlock28Prm: 1532,
  orderBlock30Prm: 1534,
  orderBlock31Prm: 1535,
  orderBlock32Prm: 1536,
  upCallBlock01Prm: 1537,
  upCallBlock02Prm: 1538,
  upCallBlock03Prm: 1539,
  upCallBlock04Prm: 1540,
  upCallBlock06Prm: 1542,
  upCallBlock07Prm: 1543,
  upCallBlock08Prm: 1544,
  upCallBlock09Prm: 1545,
  upCallBlock10Prm: 1546,
  upCallBlock11Prm: 1547,
  upCallBlock12Prm: 1548,
  upCallBlock13Prm: 1549,
  upCallBlock14Prm: 1550,
  upCallBlock15Prm: 1551,
  upCallBlock17Prm: 1553,
  upCallBlock18Prm: 1554,
  upCallBlock19Prm: 1555,
  upCallBlock20Prm: 1556,
  upCallBlock21Prm: 1557,
  upCallBlock22Prm: 1558,
  upCallBlock23Prm: 1559,
  upCallBlock24Prm: 1560,
  upCallBlock25Prm: 1561,
  upCallBlock26Prm: 1562,
  upCallBlock28Prm: 1564,
  upCallBlock29Prm: 1565,
  upCallBlock30Prm: 1566,
  upCallBlock31Prm: 1567,
  upCallBlock32Prm: 1568,
  downCallBlock01Prm: 1569,
  downCallBlock02Prm: 1570,
  downCallBlock03Prm: 1571,
  downCallBlock04Prm: 1572,
  downCallBlock05Prm: 1573,
  downCallBlock07Prm: 1575,
  downCallBlock08Prm: 1576,
  downCallBlock09Prm: 1577,
  downCallBlock10Prm: 1578,
  downCallBlock11Prm: 1579,
  downCallBlock12Prm: 1580,
  downCallBlock13Prm: 1581,
  downCallBlock14Prm: 1582,
  downCallBlock16Prm: 1584,
  downCallBlock17Prm: 1585,
  downCallBlock18Prm: 1586,
  downCallBlock19Prm: 1587,
  downCallBlock20Prm: 1588,
  downCallBlock22Prm: 1590,
  downCallBlock23Prm: 1591,
  downCallBlock24Prm: 1592,
  downCallBlock25Prm: 1593,
  downCallBlock26Prm: 1594,
  downCallBlock27Prm: 1595,
  downCallBlock28Prm: 1596,
  downCallBlock29Prm: 1597,
  downCallBlock30Prm: 1598,
  downCallBlock31Prm: 1599,
  disableShaftSecurityControlPrm: 1601,
  disableBrakeSwitchControlPrm: 1602,
  disableMDriveOverheatControlPrm: 1603,
  disableShuntsPositionControlPrm: 1604,
  disableSpeedControlPrm: 1605,
  disableDoorsPreOpenControlPrm: 1606,
  disableAssemblyRevisionSpeedControlPrm: 1608,
  disableControlScheduleModesPrm: 1609,
  disableBorderFloorSensorsPositionControlPrm: 1610,
  disableUsbCmdModeControlPrm: 1611,
  disableTopBorderFloorSensorRevisionControlPrm: 1612,
  disable15kgControlPrm: 1613,
  disable90pControlPrm: 1614,
  disable110pControlPrm: 1615,
  disableKDSRelayControlPrm: 1616,
  disableActiveEvacuatorControlPrm: 1617,
  disablePassiveEvacuatorControlPrm: 1618,
  disableRKBRelayControlPrm: 1619,
  brakeHoldingPercentagePrm: 1620,
  allowCarOverspeedPercentagePrm: 1621,
  indicationAnimationSchemePrm: 1622,
  mainDriveTypePrm: 1623,
  MFI1OperationPrm: 1624,
  MFI2OperationPrm: 1625,
  MFI3OperationPrm: 1626,
  MFI4OperationPrm: 1627,
  MFO1OperationPrm: 1628,
  MFO3OperationPrm: 1630,
  MFO4OperationPrm: 1631,
  MFO5OperationPrm: 1632,
  madLiftTimerDaysPrm: 1633,
  madLiftTimerHoursPrm: 1634,
  madLiftTimerMinutesPrm: 1635,
  controlledAccelerationTimeToHighSpeedPrm: 1637,
  controlledForcedStoppingTimeFromHighSpeedPrm: 1638,
  controlledAccelerationTimeToLowSpeedPrm: 1639,
  controlledForcedStoppingTimeFromLowSpeedPrm: 1640,
  noizeFilterUKSLWorkTimePrm: 1642,
  encoderTypePrm: 1643,
  sideADoorsBlock01Prm: 1644,
  sideADoorsBlock02Prm: 1645,
  sideADoorsBlock03Prm: 1646,
  sideADoorsBlock04Prm: 1647,
  sideADoorsBlock05Prm: 1648,
  sideADoorsBlock06Prm: 1649,
  sideADoorsBlock07Prm: 1650,
  sideADoorsBlock09Prm: 1652,
  sideADoorsBlock10Prm: 1653,
  sideADoorsBlock11Prm: 1654,
  sideADoorsBlock12Prm: 1655,
  sideADoorsBlock13Prm: 1656,
  sideADoorsBlock14Prm: 1657,
  sideADoorsBlock15Prm: 1658,
  sideADoorsBlock16Prm: 1659,
  sideADoorsBlock17Prm: 1660,
  sideADoorsBlock18Prm: 1661,
  sideADoorsBlock19Prm: 1662,
  sideADoorsBlock21Prm: 1664,
  sideADoorsBlock22Prm: 1665,
  sideADoorsBlock23Prm: 1666,
  sideADoorsBlock24Prm: 1667,
  sideADoorsBlock25Prm: 1668,
  sideADoorsBlock26Prm: 1669,
  sideADoorsBlock27Prm: 1670,
  sideADoorsBlock28Prm: 1671,
  sideADoorsBlock29Prm: 1672,
  sideADoorsBlock30Prm: 1673,
  sideADoorsBlock31Prm: 1674,
  sideBDoorsBlock01Prm: 1676,
  sideBDoorsBlock02Prm: 1677,
  sideBDoorsBlock03Prm: 1678,
  sideBDoorsBlock04Prm: 1679,
  sideBDoorsBlock05Prm: 1680,
  sideBDoorsBlock06Prm: 1681,
  sideBDoorsBlock07Prm: 1682,
  sideBDoorsBlock08Prm: 1683,
  sideBDoorsBlock09Prm: 1684,
  sideBDoorsBlock10Prm: 1685,
  sideBDoorsBlock12Prm: 1687,
  sideBDoorsBlock13Prm: 1688,
  sideBDoorsBlock14Prm: 1689,
  sideBDoorsBlock15Prm: 1690,
  sideBDoorsBlock16Prm: 1691,
  sideBDoorsBlock17Prm: 1692,
  sideBDoorsBlock18Prm: 1693,
  sideBDoorsBlock19Prm: 1694,
  sideBDoorsBlock20Prm: 1695,
  sideBDoorsBlock21Prm: 1696,
  sideBDoorsBlock22Prm: 1697,
  sideBDoorsBlock24Prm: 1699,
  sideBDoorsBlock25Prm: 1700,
  sideBDoorsBlock26Prm: 1701,
  sideBDoorsBlock28Prm: 1703,
  sideBDoorsBlock29Prm: 1704,
  sideBDoorsBlock30Prm: 1705,
  sideBDoorsBlock32Prm: 1707,
  VKZReactionTimePrm: 1708,
  sideASafeZone01Prm: 1709,
  sideASafeZone02Prm: 1710,
  sideASafeZone03Prm: 1711,
  sideASafeZone04Prm: 1712,
  sideASafeZone05Prm: 1713,
  sideASafeZone06Prm: 1714,
  sideASafeZone07Prm: 1715,
  sideASafeZone08Prm: 1716,
  sideASafeZone09Prm: 1717,
  sideASafeZone10Prm: 1718,
  sideASafeZone12Prm: 1720,
  sideASafeZone13Prm: 1721,
  sideASafeZone14Prm: 1722,
  sideASafeZone15Prm: 1723,
  sideASafeZone16Prm: 1724,
  sideASafeZone17Prm: 1725,
  sideASafeZone18Prm: 1726,
  sideASafeZone19Prm: 1727,
  sideASafeZone20Prm: 1728,
  sideASafeZone21Prm: 1729,
  sideASafeZone23Prm: 1731,
  sideASafeZone24Prm: 1732,
  sideASafeZone25Prm: 1733,
  sideASafeZone26Prm: 1734,
  sideASafeZone27Prm: 1735,
  sideASafeZone28Prm: 1736,
  sideASafeZone29Prm: 1737,
  sideASafeZone30Prm: 1738,
  sideASafeZone31Prm: 1739,
  sideASafeZone32Prm: 1740,
  sideBSafeZone02Prm: 1742,
  sideBSafeZone03Prm: 1743,
  sideBSafeZone04Prm: 1744,
  sideBSafeZone05Prm: 1745,
  sideBSafeZone06Prm: 1746,
  sideBSafeZone07Prm: 1747,
  sideBSafeZone08Prm: 1748,
  sideBSafeZone09Prm: 1749,
  sideBSafeZone10Prm: 1750,
  sideBSafeZone11Prm: 1751,
  sideBSafeZone13Prm: 1753,
  sideBSafeZone14Prm: 1754,
  sideBSafeZone15Prm: 1755,
  sideBSafeZone16Prm: 1756,
  sideBSafeZone17Prm: 1757,
  sideBSafeZone18Prm: 1758,
  sideBSafeZone19Prm: 1759,
  sideBSafeZone20Prm: 1760,
  sideBSafeZone21Prm: 1761,
  sideBSafeZone22Prm: 1762,
  sideBSafeZone24Prm: 1764,
  sideBSafeZone25Prm: 1765,
  sideBSafeZone26Prm: 1766,
  negativeFloorsNumber: 1778,
  zeroFloorExists: 1779,
  stopsNumberTotal: 1780,
  currentStop: 1781,
  doorsStateUnknown: 1782,
  doorsOpens: 1783,
  doorsOpened: 1784,
  doorsClosing: 1785,
  doorsClosed: 1786,
  doorsClosedCompletly: 1787,
  doorsBlocked: 1788,
  doorsMissing: 1789,
  movementUnknown: 1790,
  cabinMoving: 1791,
  cabinMovingUp: 1792,
  cabinMovingDown: 1793,
  cabinNotMoving: 1794,
  cabinStanding: 1795,
  movingUpForward: 1796,
  movingDownBottom: 1797,
  idleEnergySaving: 1798,
  movingUpForwardEnergySaving: 1799,
  movingDownBottomEnergySaving: 1800,
  idleAuto: 1801,
  movingUpForwardAuto: 1802,
  movingDownBottomAuto: 1803,
  safetyChainStart: 1804,
  afterSafetyDevicesState: 1805,
  afterCabinDoorsState: 1806,
  afterShaftDoorsState: 1807,
  safetyChainEnd: 1808,
  elevatorShaftDoorsState: 1809,
  elevatorUnknownState: 1810,
  elevatorConnected: 1811,
  elevatorOutOfService: 1812,
  elevatorWorkMode: 1813,
  cabinLoadPercent: 1814,
  controlCircuitVoltage: 1815,
  beforeStopCircuit: 1816,
  afterStopCircuit: 1817,
  beforeCabinDoorsCircuit: 1818,
  afterCabinDoorsCircuit: 1819,
  doorControlRelay: 1820,
  doorRelayForOpening: 1821,
  doorRelayForClosing: 1822,
  drivingRelay: 1823,
  autoLock: 1824,
  sideBSafeZone28Prm: 1768,
  sideBSafeZone29Prm: 1769,
  sideBSafeZone30Prm: 1770,
  sideBSafeZone31Prm: 1771,
  currentProfilePrm: 1773,
  totalUptime: 1,
  carSpeedWhole: 430,
  machineRoomSensor: 1825,
  callButton: 1826,
  lineConditionImpulsesExists: 1827,
  speechInfromantDetected: 1828,
  elevatorPowerButton: 1829,
  dispatcherCallFromMachineRoom: 1830,
  userInput1: 1831,
  userInput2: 1832,
  userInput3: 1833,
  userInput4: 1834,
  powerSupplyAvailability: 1835,
  currentOutputState: 1836,
  doorsState: 1837,
  elevatorMovementUp: 1838,
  elevatorMovementDown: 1839,
  weight15kgSignal: 1840,
  weight90PercentsSignal: 1841,
  weight110PercentsSignal: 1842,
  controlStationIncident: 1843,
  precisionStopSensor: 1844,
  powerSupplyOutState: 1845,
  out1State: 1846,
  userOut1State: 1847,
  userOut2State: 1848,
  userOut3State: 1849,
  userOut4State: 1850,
  canPowerOutState: 1851,
  out4State: 1852,
  order1: 1853,
  order2: 1854,
  order3: 1855,
  order4: 1856,
  order5: 1857,
  order6: 1858,
  order7: 1859,
  order8: 1860,
  order9: 1861,
  order10: 1862,
  order11: 1863,
  order12: 1864,
  order15: 1867,
  order16: 1868,
  order17: 1869,
  order18: 1870,
  order19: 1871,
  order20: 1872,
  order21: 1873,
  order22: 1874,
  order23: 1875,
  order24: 1876,
  order25: 1877,
  order26: 1878,
  order27: 1879,
  order28: 1880,
  order29: 1881,
  order30: 1882,
  order31: 1883,
  order32: 1884,
  order33: 1885,
  order34: 1886,
  order35: 1887,
  order36: 1888,
  order37: 1889,
  order38: 1890,
  order39: 1891,
  order40: 1892,
  order41: 1893,
  order42: 1894,
  order44: 1896,
  order45: 1897,
  order46: 1898,
  order47: 1899,
  order48: 1900,
  order49: 1901,
  order50: 1902,
  order51: 1903,
  order52: 1904,
  order53: 1905,
  order54: 1906,
  order55: 1907,
  order56: 1908,
  order57: 1909,
  order58: 1910,
  order59: 1911,
  order60: 1912,
  order61: 1913,
  order62: 1914,
  order63: 1915,
  order64: 1916,
  upCallA1: 1917,
  upCallA2: 1918,
  upCallA3: 1919,
  upCallA4: 1920,
  upCallA5: 1921,
  upCallA6: 1922,
  upCallA7: 1923,
  upCallA8: 1924,
  upCallA9: 1925,
  upCallA10: 1926,
  upCallA11: 1927,
  upCallA12: 1928,
  upCallA13: 1929,
  upCallA14: 1930,
  upCallA15: 1931,
  upCallA16: 1932,
  upCallA17: 1933,
  upCallA18: 1934,
  upCallA19: 1935,
  upCallA20: 1936,
  upCallA21: 1937,
  upCallA22: 1938,
  upCallA23: 1939,
  upCallA24: 1940,
  upCallA25: 1941,
  upCallA26: 1942,
  upCallA27: 1943,
  upCallA28: 1944,
  upCallA29: 1945,
  upCallA30: 1946,
  upCallA31: 1947,
  upCallA32: 1948,
  upCallA33: 1949,
  upCallA34: 1950,
  upCallA35: 1951,
  upCallA36: 1952,
  upCallA37: 1953,
  upCallA38: 1954,
  upCallA39: 1955,
  upCallA40: 1956,
  upCallA41: 1957,
  upCallA42: 1958,
  upCallA43: 1959,
  upCallA44: 1960,
  upCallA45: 1961,
  upCallA46: 1962,
  upCallA47: 1963,
  upCallA48: 1964,
  upCallA49: 1965,
  upCallA50: 1966,
  upCallA51: 1967,
  upCallA52: 1968,
  upCallA53: 1969,
  upCallA54: 1970,
  upCallA55: 1971,
  upCallA56: 1972,
  upCallA57: 1973,
  upCallA58: 1974,
  upCallA59: 1975,
  upCallA60: 1976,
  upCallA61: 1977,
  upCallA62: 1978,
  upCallA63: 1979,
  upCallA64: 1980,
  downCallA1: 1981,
  downCallA2: 1982,
  downCallA3: 1983,
  downCallA4: 1984,
  downCallA5: 1985,
  downCallA6: 1986,
  downCallA7: 1987,
  downCallA8: 1988,
  downCallA9: 1989,
  downCallA10: 1990,
  downCallA11: 1991,
  downCallA12: 1992,
  downCallA13: 1993,
  downCallA14: 1994,
  downCallA15: 1995,
  downCallA16: 1996,
  downCallA17: 1997,
  downCallA18: 1998,
  downCallA19: 1999,
  downCallA20: 2000,
  downCallA21: 2001,
  downCallA22: 2002,
  downCallA23: 2003,
  downCallA24: 2004,
  downCallA25: 2005,
  downCallA26: 2006,
  downCallA27: 2007,
  downCallA28: 2008,
  downCallA29: 2009,
  downCallA30: 2010,
  downCallA31: 2011,
  downCallA32: 2012,
  downCallA33: 2013,
  downCallA34: 2014,
  downCallA35: 2015,
  downCallA36: 2016,
  downCallA37: 2017,
  downCallA38: 2018,
  downCallA39: 2019,
  downCallA40: 2020,
  downCallA41: 2021,
  downCallA42: 2022,
  downCallA43: 2023,
  downCallA44: 2024,
  downCallA45: 2025,
  downCallA46: 2026,
  downCallA47: 2027,
  downCallA48: 2028,
  downCallA49: 2029,
  downCallA50: 2030,
  downCallA51: 2031,
  downCallA52: 2032,
  downCallA53: 2033,
  downCallA54: 2034,
  downCallA55: 2035,
  downCallA56: 2036,
  downCallA57: 2037,
  downCallA58: 2038,
  downCallA59: 2039,
  downCallA60: 2040,
  downCallA61: 2041,
  downCallA62: 2042,
  downCallA63: 2043,
  downCallA64: 2044,
  upCallB1: 2045,
  upCallB2: 2046,
  upCallB3: 2047,
  upCallB4: 2048,
  upCallB5: 2049,
  upCallB6: 2050,
  upCallB7: 2051,
  upCallB8: 2052,
  upCallB9: 2053,
  upCallB10: 2054,
  upCallB11: 2055,
  upCallB12: 2056,
  upCallB13: 2057,
  upCallB14: 2058,
  upCallB15: 2059,
  upCallB16: 2060,
  upCallB17: 2061,
  upCallB18: 2062,
  upCallB19: 2063,
  upCallB20: 2064,
  upCallB21: 2065,
  upCallB22: 2066,
  upCallB23: 2067,
  upCallB24: 2068,
  upCallB25: 2069,
  upCallB26: 2070,
  upCallB27: 2071,
  upCallB28: 2072,
  upCallB29: 2073,
  upCallB30: 2074,
  upCallB31: 2075,
  upCallB32: 2076,
  upCallB33: 2077,
  upCallB34: 2078,
  upCallB35: 2079,
  upCallB36: 2080,
  upCallB37: 2081,
  upCallB38: 2082,
  upCallB39: 2083,
  upCallB40: 2084,
  upCallB41: 2085,
  upCallB42: 2086,
  upCallB43: 2087,
  upCallB44: 2088,
  upCallB45: 2089,
  upCallB46: 2090,
  upCallB47: 2091,
  upCallB48: 2092,
  upCallB49: 2093,
  upCallB50: 2094,
  upCallB51: 2095,
  upCallB52: 2096,
  upCallB53: 2097,
  upCallB54: 2098,
  upCallB55: 2099,
  upCallB56: 2100,
  upCallB57: 2101,
  upCallB58: 2102,
  upCallB59: 2103,
  upCallB60: 2104,
  upCallB61: 2105,
  upCallB62: 2106,
  upCallB63: 2107,
  upCallB64: 2108,
  downCallB1: 2109,
  downCallB2: 2110,
  downCallB3: 2111,
  downCallB4: 2112,
  downCallB5: 2113,
  downCallB6: 2114,
  downCallB7: 2115,
  downCallB8: 2116,
  downCallB9: 2117,
  downCallB10: 2118,
  downCallB11: 2119,
  downCallB12: 2120,
  downCallB13: 2121,
  downCallB14: 2122,
  downCallB15: 2123,
  downCallB16: 2124,
  downCallB17: 2125,
  downCallB18: 2126,
  downCallB19: 2127,
  downCallB20: 2128,
  downCallB21: 2129,
  downCallB22: 2130,
  downCallB23: 2131,
  downCallB24: 2132,
  downCallB25: 2133,
  downCallB26: 2134,
  downCallB27: 2135,
  downCallB28: 2136,
  downCallB29: 2137,
  downCallB30: 2138,
  downCallB31: 2139,
  downCallB32: 2140,
  downCallB33: 2141,
  downCallB34: 2142,
  downCallB35: 2143,
  downCallB36: 2144,
  downCallB37: 2145,
  downCallB38: 2146,
  downCallB39: 2147,
  downCallB40: 2148,
  downCallB41: 2149,
  downCallB42: 2150,
  downCallB43: 2151,
  downCallB44: 2152,
  downCallB45: 2153,
  downCallB46: 2154,
  downCallB47: 2155,
  downCallB48: 2156,
  downCallB49: 2157,
  downCallB50: 2158,
  downCallB51: 2159,
  downCallB52: 2160,
  downCallB53: 2161,
  downCallB54: 2162,
  downCallB55: 2163,
  downCallB56: 2164,
  downCallB57: 2165,
  downCallB58: 2166,
  downCallB59: 2167,
  downCallB60: 2168,
  downCallB61: 2169,
  downCallB62: 2170,
  downCallB63: 2171,
  downCallB64: 2172,
  mainDriveLaunchesTotal: 2173,
  mainDriveWorkTimeSeconds: 2174,
  doorsDriveLaunchesTotal: 2175,
  doorsDriveWorkTimeSeconds: 2176,
  floorNumberOfFirstOpenedDoor: 2177,
  floorNumberOfSecondOpenedDoor: 2178,
  callSource: 2179,
  restartCode: 2180,
  restartCounter: 2181,
  maintenanceState: 2182,
  blockRestartHappens: 2183,
  multipleDoorsReverse: 2184,
  machineRoomUnauthorizeEntry: 2185,
  noVoltageInControlCircuit: 2186,
  cabinStopButtonPressed: 2187,
  cabinDoorDontClosed: 2188,
  secureCircuitBreak: 2189,
  secureDeivceSensorDidNotWork: 2190,
  secureChainShortCircuit: 2191,
  dispatcherCall: 2192,
  unauthorizedCabinMoving: 2193,
  mainDriveFailure: 2194,
  mainDoorsDriveFailure: 2195,
  shaftUnautorizedEntry: 2196,
  secureDeviceFailure: 2197,
  emergencyElevatorBlock: 2198,
  machineRoomIsOpen: 2199,
  elevatorBetweenFloors: 2200,
  doorsSensorFailure: 2201,
  noConnectionWithControlStation: 2202,
  mainDriveOn: 2203,
  userBit: 2204,
  triggerMechanism: 2205,
  movingRelayBlock: 2206,
  dispatcherCallClassification: 2207,
  loudspeakerFailure: 2208,
  user1State: 2209,
  user2State: 2210,
  user3State: 2211,
  user4State: 2212,
  elevatorBlockBackupPowerSupply: 2213,
  centeralBlockAlternatingVoltage: 2214,
  fireHazard: 2215,
  powerBatteryFail: 2216,
  elevatorBlockBatteryChargeState: 2217,
  elevatorBlockBatteryCharge: 2218,
  elevatorBlockDeviceBackupPowerSupply: 2219,
  cabinCurrentCommuncationChannelCAN: 2220,
  cabinCurrentCommuncationChannelWIFI: 2221,
  cabinCanChannelAvailability: 2222,
  cabinWifiChannelAvailability: 2223,
  cabinLoudspeakerState: 2224,
  cabinPppState: 2225,
  cabinLoudspeakerTestComplete: 2226,
  cabinLoudspeakerTestResult: 2227,
  cabinBatteryChargeState: 2228,
  cabinBatteryCharge: 2229,
  cabinDeviceBackupPowerSupply: 2230,
  pitBatteryChargeState: 2231,
  pitBatteryCharge: 2232,
  pitDeviceBackupPowerSupply: 2233,
  pitCurrentCommuncationChannelCAN: 2234,
  pitCurrentCommuncationChannelWIFI: 2235,
  pitCanChannelAvailability: 2236,
  pitWifiChannelAvailability: 2237,
  pitLoudspeakerState: 2238,
  pitPppState: 2239,
  pitLoudspeakerTestComplete: 2240,
  pitLoudspeakerTestResult: 2241,
  driveOverheat: 6,
  tempLoadSwitchings: 20,
  signalAdd1DNESwitchings: 31,
  registeredOrders: 48,
  timeOfSignalOpenDoorsA: 50,
  doorsClosed02: 66,
  doorsOpened05: 80,
  orders08: 94,
  doorsClosed09: 101,
  doorsClosed10: 106,
  doorsOpened13: 120,
  doorsOpened16: 135,
  doorsOpened19: 150,
  downCalls20: 153,
  doorsOpened21: 160,
  doorsOpened24: 175,
  downCalls27: 188,
  doorsClosed29: 201,
  doorsOpened30: 205,
  doorsOpened32: 215,
  sleepModeStartM: 230,
  mornModeStatus: 242,
  placePostCode: 256,
  lastPowerUpWDay: 262,
  lastPowerUpYear: 265,
  FCSELTCmd: 272,
  BrakeCmd: 286,
  addSpeedSensorSgl: 294,
  can8ConState: 312,
  mC6_SK9: 325,
  mC7_SK9: 326,
  mC2_SK11: 337,
  mC4_SK12: 347,
  mC6_SK13: 357,
  mC1_SK15: 368,
  mC3_SK16: 378,
  RKBRelayState: 384,
  modeToggleSwitchPosition: 393,
  VKODoorSideASgl: 411,
  MBMInstalledSideBFlag: 423,
  mC1_SK3: 448,
  mC7_SK3: 454,
  mC2_SK4: 457,
  mC5_SK5: 468,
  mC7_SK6: 478,
  mC1_SK8: 488,
  mC4_SK17: 499,
  mC6_SK18: 509,
  mC8_SK19: 519,
  mC5_SK20: 524,
  mC8_SK20: 527,
  mC2_SK22: 537,
  mC4_SK23: 547,
  mC7_SK24: 558,
  realTimeClockFlag: 566,
  lastErrorCodeHighByte: 576,
  litOrder10: 590,
  litOrder15: 595,
  litOrder26: 606,
  litOrder36: 616,
  litOrder46: 626,
  litOrder57: 637,
  btnPressOrder02: 646,
  btnPressOrder13: 657,
  btnPressOrder14: 658,
  btnPressOrder21: 665,
  btnPressOrder32: 676,
  btnPressOrder44: 688,
  btnPressOrder56: 700,
  litUpCall04: 712,
  litUpCall12: 720,
  litUpCall14: 722,
  litUpCall25: 733,
  litUpCall36: 744,
  litUpCall47: 755,
  litUpCall58: 766,
  btnPressUpCall03: 775,
  btnPressUpCall11: 783,
  btnPressUpCall16: 788,
  btnPressUpCall29: 801,
  btnPressUpCall42: 814,
  btnPressUpCall55: 827,
  litDownCall02: 838,
  litDownCall08: 844,
  litDownCall19: 855,
  litDownCall30: 866,
  litDownCall41: 877,
  litDownCall52: 888,
  litDownCall63: 899,
  btnPressDownCall03: 903,
  btnPressDownCall06: 906,
  btnPressDownCall19: 919,
  btnPressDownCall32: 932,
  btnPressDownCall45: 945,
  btnPressDownCall58: 958,
  btnPressDownCall63: 963,
  leftSymbolLevel01: 1244,
  rightSymbolLevel06: 1255,
  rightSymbolLevel13: 1269,
  rightSymbolLevel19: 1281,
  leftSymbolLevel20: 1282,
  rightSymbolLevel20: 1283,
  rightSymbolLevel26: 1295,
  rightSymbolLevel32: 1307,
  upwardLeveling06: 1319,
  upwardLeveling13: 1333,
  downwardLeveling14: 1334,
  downwardLeveling15: 1336,
  downwardLeveling22: 1350,
  debugRevModeFlag: 1097,
  topEdgeLevel: 1108,
  levContCon03: 1118,
  levContCon08: 1123,
  levContCon20: 1135,
  levContCon32: 1147,
  levContCon45: 1160,
  levContCon57: 1172,
  levContCon61: 1176,
  shaftDoorsState03: 1182,
  shaftDoorsState15: 1194,
  shaftDoorsState26: 1205,
  shaftDoorsState38: 1217,
  shaftDoorsState50: 1229,
  downwardLeveling31: 1368,
  bottomEdgeLiftHeightL22: 1417,
  bottomEdgeLiftHeightL25: 1420,
  topEdgeLiftHeightL10: 1437,
  topEdgeLiftHeightL27: 1454,
  topEdgeLiftHeightL31: 1458,
  blockFireEmergencyResetPrm: 1474,
  maxDoorsReverseCountPrm: 1493,
  orderBlock07Prm: 1511,
  orderBlock11Prm: 1515,
  orderBlock19Prm: 1523,
  orderBlock29Prm: 1533,
  upCallBlock05Prm: 1541,
  upCallBlock16Prm: 1552,
  upCallBlock27Prm: 1563,
  downCallBlock06Prm: 1574,
  downCallBlock15Prm: 1583,
  downCallBlock21Prm: 1589,
  downCallBlock32Prm: 1600,
  disableLevelingWithOpenedDoorsControlPrm: 1607,
  MFO2OperationPrm: 1629,
  controlledStopTimeFromLevelingToHoldingPrm: 1636,
  hoistMaxRotationSpeedPrm: 1641,
  sideADoorsBlock08Prm: 1651,
  sideADoorsBlock20Prm: 1663,
  sideADoorsBlock32Prm: 1675,
  sideBDoorsBlock11Prm: 1686,
  sideBDoorsBlock23Prm: 1698,
  sideBDoorsBlock27Prm: 1702,
  sideBDoorsBlock31Prm: 1706,
  sideASafeZone11Prm: 1719,
  sideASafeZone22Prm: 1730,
  sideBSafeZone01Prm: 1741,
  sideBSafeZone12Prm: 1752,
  sideBSafeZone23Prm: 1763,
  sideBSafeZone27Prm: 1767,
  sideBSafeZone32Prm: 1772,
}

export default parameterIdToSourceIdMap
